// extracted by mini-css-extract-plugin
export var bgLoading = "index-module--bg-loading--0f14f";
export var borderLoading = "index-module--border-loading--791b2";
export var breakBorderLoading = "index-module--break-border-loading--192d1";
export var gradient = "index-module--gradient--43a65";